module.exports = __webpack_public_path__ + "assets/img/chx_d_2.793e8e03.png";